// extracted by mini-css-extract-plugin
export default {"container":"CardDiferenciais_container__sjuMb","content":"CardDiferenciais_content__QSV6A","column":"CardDiferenciais_column__UhsgX"};